export enum DataLoadingStatus {
    Loading = "Loading",
    Loaded = "Loaded",
    NotFound = "NotFound",
    Error = "Error",
  }